import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useCurrentTeacher from '../../../hooks/useCurrentTeacher';
import MyCourses from './MyCourses';
import useCategories from '../../../hooks/useCategories';
import Filters from '../Filters';
const BASE_URL = process.env.REACT_APP_BASE_URL;

const TeacherCourses = () => {
  const {search,setSearch,category,setCategory,categories}=useCategories()
  const navigate = useNavigate();
  const { teacher } = useCurrentTeacher();

  const [loading, setLoading] = useState(true);
  const [courses, setCourses] = useState([]);

  // Fetch teacher courses
  useEffect(() => {
    if (!teacher?.id) return;

    setLoading(true);

    fetch(`${BASE_URL}/courses/list/?teacher_id=${teacher.id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        'Content-Type': 'application/json',
        "x-api-key": process.env.REACT_APP_X_API_KEY
      },
    })
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) setCourses(data);
        else if (data.results && Array.isArray(data.results)) setCourses(data.results);
        else setCourses([]);
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setLoading(false);
      });
  }, [teacher?.id]);

  // Filter courses by category ID
 
  const filteredSearch=courses.filter((item)=>item.name.toLocaleLowerCase().includes(search))
  const filteredCourses = filteredSearch.filter(
  item => !category || item.category_name === category
);
  // Navigation handlers
  const handleViewDetails = courseId => {
    navigate(`/teacher/course/${courseId}`);
  };

  const handleAddCourseContent = courseId => {
    navigate(`/teacher/course/list-content/${courseId}`);
  };

  // Format price
  const formatPrice = (price, courseType) => {
    if (courseType === 'free') return 'Free';
    return `$${parseFloat(price).toFixed(2)}`;
  };

  return (
   <div className="min-h-screen px-4 py-6">
  {/* Header */}
  <div className="flex justify-between items-start mb-8 max-w-[1500px] mx-auto">
    <div>
      <div className="flex items-center gap-3 mb-2">
        <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
          <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
          </svg>
        </div>
        <h1 className="text-2xl font-semibold text-gray-900">My Courses</h1>
      </div>
      <p className="text-sm text-gray-500 ml-14">Manage and organize your teaching materials</p>
    </div>
    <button 
      className="px-6 py-3 bg-[#0f6abf] text-white rounded-xl text-sm font-semibold cursor-pointer hover:bg-[#0a5ca8] transition-colors flex items-center gap-2 shadow-sm hover:shadow-md"
      onClick={()=>navigate('/teacher/course/create')}
    >
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
      </svg>
      Add New Course
    </button>
  </div>

  {/* Filters */}
  <div className="max-w-[1500px] mx-auto mb-8">
    <Filters 
      search={search} 
      setSearch={setSearch} 
      category={category} 
      setCategory={setCategory} 
      categories={categories}
    />
  </div>

  {/* Courses Grid */}
  <div className="max-w-[1500px] mx-auto">
    <MyCourses
      loading={loading}
      filteredCourses={filteredCourses}
      formatPrice={formatPrice}
      handleViewDetails={handleViewDetails}
      handleAddCourseContent={handleAddCourseContent}
    />
  </div>
</div>
  );
};

export default TeacherCourses;
